import { graphql } from '../../gql/wrapper/gql'

export const getRedirects = graphql(`
  query getRedirects {
    allMkRedirect(where: { mk_enabled: { eq: true }, _: { is_draft: false } }) {
      mk_old_path
      mk_new_path
    }
  }
`)

export default getRedirects
